import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import * as reportsActions from '../../actions/Reports';
import LocaleComponent from '../../LocaleComponent';
import { dateFormatter, adTypeFormatter, adFormatter, statusFormatter, publisherFormatter, adNameFormatter } from '../Formatter';
import SearchBox from '../../components/SearchBox';
import FilterDropDown from '../../components/FilterDropDown';

class Ads extends LocaleComponent {
  static propTypes = {
    campaigns: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      params: {
        mcId: '',
        publisherFilter: this._all,
        adGroupFilter: this._all,
        typeFilter: this._all,
        statusFilter: this._all,
        searchText: '',
        accountId: '',
        campaignId: '',
        adId: '',
      },
      campaigns: [],
      availablePublishers: [],
      availableAdGroups: [],
      availableTypes: [],
      availableStatus: [],
      filteredData: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    const { campaigns, location } = nextProps;
    const params = this.parseParams(location.search);
    this.load(params, {campaigns});
  }

  componentDidMount() {
    const newParams = this.checkParams();

    if (newParams) {
      this.mergeParams(newParams);
    }

    const { campaigns } = this.props;
    if (campaigns.campaigns) {
      this.load({}, {campaigns})
    } else {
      const id = this.getMcId();
      this.props.getCampaigns(id);
    }

    this.props.selectMenu('ads');
  }

  findAdGroup(intAG) {
    return this.props.groupedAdGroups[intAG] || null;
  }

  findCampaign(intCampaign) {
    return this.props.indexedCampaigns[intCampaign] || {};
  }

  onAdGroupFilterClick = adGroupFilter => {
    const path = this.stringfyWithNew({ adGroupFilter });
    this.props.history.replace(path);
    this.load({ adGroupFilter });
  };

  onTypeFilterClick = typeFilter => {
    const path = this.stringfyWithNew({ typeFilter });
    this.props.history.replace(path);
    this.load({ typeFilter });
  };

  onStatusFilterClick = statusFilter => {
    const path = this.stringfyWithNew({ statusFilter });
    this.props.history.replace(path);
    this.load({ statusFilter });
  };

  onPublisherFilterClick = publisherFilter => {
    const path = this.stringfyWithNew({ publisherFilter });
    this.props.history.replace(path);
    this.load({ publisherFilter });
  };

  onSearchTextChanged = e => {
    const searchText = e.target.value;
    const path = this.stringfyWithNew({ searchText });
    this.props.history.replace(path);
    this.load({ searchText });
  };

  load(newParam, newState) {
    const params = this.mergeValues(this.state.params, newParam);
    const { publisherFilter, typeFilter, statusFilter, adGroupFilter, searchText } = params;
    const { accountId, campaignId, adId, agId } = newParam;
    const { campaigns } = this.mergeValues(this.state, newState);
    const ads = campaigns.ads;

    this.props.setSpin(true);

    const filteredAds = (ads) ? ads.filter(ad => {
      const a = !accountId || ad.Account.toString() === accountId;
      const b = !campaignId || ad.intCampaign.toString() === campaignId;
      const c = !adId || ad['Ad ID'].toString() === adId;
      const d = !agId || ad.intAG.toString() === agId;
      return a && b && c && d;
    }):[];

    // populate the items
    const data = filteredAds.map(item => {
      const adGroup = this.findAdGroup(item.intAG);
      const campaign = this.findCampaign(item.intCampaign);

      const name = {
        Campaign: campaign.Campaign,
        adGroup: adGroup ? adGroup.AdGroup : '',
        Ad_Name: item.Ad_Name,
        display_url: item.display_url,
      };
      return {
        account: item.Account,
        ad: {
          type: item.AdType,
          content: item.Advertisement,
        },
        ID: item['Ad ID'],
        adType: item.AdType,
        adGroup: adGroup ? adGroup.AdGroup : '',
        name,
        publisher: item.Publisher,
        status: item.Status,
        lastUpdated: item.last_updated
      };
    });

    // initialize filters
    const availablePublishers = [this._all];
    const availableAdGroups = [this._all];
    const availableTypes = [this._all];
    const availableStatus = [this._all];

    data.forEach(item => {
      if (item.publisher !== '' && availablePublishers.indexOf(item.publisher) === -1) {
        availablePublishers.push(item.publisher)
      }
      if (item.adGroup !== '' && availableAdGroups.indexOf(item.adGroup) === -1) {
        availableAdGroups.push(item.adGroup)
      }
      if (item.adType !== '' && availableTypes.indexOf(item.adType) === -1) {
        availableTypes.push(item.adType)
      }
      if (item.status !== '' && availableStatus.indexOf(item.status) === -1) {
        availableStatus.push(item.status)
      }
    });

    // apply filter
    const filteredData = data.filter(item => {
      return (
          (publisherFilter !== this._all) ?
            (item.publisher === publisherFilter) : true
        ) && (
          (adGroupFilter !== this._all) ?
            (item.adGroup === adGroupFilter) : true
        ) && (
          (typeFilter !== this._all) ?
            (item.adType.toString() === typeFilter) : true
        ) && (
          (statusFilter !== this._all) ?
            (item.status.toString() === statusFilter) : true
        ) && (
          (item.ad.content && item.ad.content.indexOf(searchText) !== -1) ||
          (item.name.Campaign && item.name.Campaign.indexOf(searchText) !== -1) ||
          (item.name.adGroup && item.name.adGroup.indexOf(searchText) !== -1) ||
          (item.name.Ad_Name && item.name.Ad_Name.indexOf(searchText) !== -1) ||
          (item.name.display_url && item.name.display_url.indexOf(searchText) !== -1) ||
          (item.ID && item.ID.toString().indexOf(searchText) !== -1)
        );
    });

    const updatedStates = Object.assign({},
      {
        availablePublishers,
        availableAdGroups,
        availableTypes,
        availableStatus,
        filteredData,
      },
      newState,
      {
        params: this.mergeValues(this.state.params, newParam)
      });

    this.setState(updatedStates);

    this.props.setSpin(false);
  }

  render() {
    const {
      availablePublishers,
      availableAdGroups,
      availableTypes,
      availableStatus,
      filteredData,
      params,
    } = this.state;
    const {
      searchText,
      publisherFilter,
      adGroupFilter,
      typeFilter,
      statusFilter,
    } = params;

    const filterBox = (
      <div className="form-group">
        <div className="input-group">
          <div className="input-group-btn">
            <span className="input-group-addon">
              <i className="fa fa-filter" /> &nbsp;
              {this.localeMessage('Filter')}
            </span>
            <FilterDropDown title={this.localeMessage('Publisher')}
                            data={availablePublishers}
                            filter={publisherFilter}
                            onClick={this.onPublisherFilterClick}/>
            <FilterDropDown title={this.localeMessage('AdGroups')}
                            data={availableAdGroups}
                            filter={adGroupFilter}
                            onClick={this.onAdGroupFilterClick}/>
            <FilterDropDown title={this.localeMessage('TYPE')}
                            data={availableTypes}
                            filter={typeFilter}
                            onClick={this.onTypeFilterClick}/>
            <FilterDropDown title={this.localeMessage('STATUS')}
                            data={availableStatus}
                            filter={statusFilter}
                            onClick={this.onStatusFilterClick}/>
          </div>
        </div>
      </div>
    );

    const DataTable = (props) => {
      const itemCount = props.data.length;

      const renderPaginationPanel = (props) => {
        return (
          <div style={{margin: '20px'}}>
            <div>{ props.components.pageList }</div>
            <div>
              <span>{this.localeMessage('Change size per page')}: </span>
              { props.components.sizePerPageDropdown }
              <span>&nbsp; {props.pageStartIndex} of {itemCount}</span>
            </div>
          </div>
        );
      };

      const pagination = itemCount > 10;
      const options = pagination ? {
        paginationPanel: renderPaginationPanel,
        sizePerPageList: [
          { text: '50', value: 50 },
          { text: '100', value: 100 },
          { text: '200', value: 200 },
          { text: 'All', value: itemCount} ],
        sizePerPage: 50,
        // paginationPosition: 'top'
      } : {};

      return (
        <BootstrapTable data={props.data} options={options} pagination={pagination}>
          <TableHeaderColumn width='50' dataField='publisher' dataFormat={publisherFormatter} />
          <TableHeaderColumn width='300' dataField={'ad'} dataFormat={adFormatter}>
            {this.localeMessage('Ad')}
          </TableHeaderColumn>
          <TableHeaderColumn width='130' dataField={'ID'} isKey>
            {this.localeMessage('ID')}
          </TableHeaderColumn>
          <TableHeaderColumn width='150' dataField={'adType'} dataFormat={adTypeFormatter}>
            {this.localeMessage('TYPE')}
          </TableHeaderColumn>
          <TableHeaderColumn dataField={'name'} dataFormat={adNameFormatter}>
            {this.localeMessage('Name')}
          </TableHeaderColumn>
          <TableHeaderColumn width='100' dataField={'status'} dataFormat={statusFormatter}>
            {this.localeMessage('STATUS')}
          </TableHeaderColumn>
          <TableHeaderColumn width='200' dataField={'lastUpdated'} dataFormat={dateFormatter}>
            {this.localeMessage('Last Updated')}
          </TableHeaderColumn>
        </BootstrapTable>
      );
    };

    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-lg-3">
            <SearchBox searchText={searchText} onSearchTextChanged={this.onSearchTextChanged}/>
          </div>
          <div className="col-lg-9">
            {filterBox}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DataTable data={filteredData} />
          </div>
        </div>
      </div>
    );
  }
}

class AdsContainer extends Component {
  render() {
    return <Ads
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

AdsContainer = connect(state => ({
  customers: state.reports.get('customers'),
  campaigns: state.reports.get('campaigns'),
  groupedAdGroups: state.reports.get('groupedAdGroups'),
  indexedCampaigns: state.reports.get('indexedCampaigns'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
}))(AdsContainer);

export default AdsContainer;



// WEBPACK FOOTER //
// ./src/views/Ads/Ads.js